/* eslint-disable no-param-reassign */
/* eslint-disable import/no-unresolved */
import {
  Swiper,
  Navigation,
  Keyboard,
  A11y,
} from 'swiper';

const fullWidthGalleryClickHandlers = new WeakMap();

function setNavDisabled(btn, isDisabled) {
  btn.classList.toggle('disabled', isDisabled);
  btn.disabled = isDisabled;
  btn.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
}

function initFullWidthGalleryRoot(rootEl) {
  if (!rootEl) {
    return;
  }

  const staleClickHandler = fullWidthGalleryClickHandlers.get(rootEl);
  if (staleClickHandler) {
    rootEl.removeEventListener('click', staleClickHandler);
    fullWidthGalleryClickHandlers.delete(rootEl);
  }

  const swiperEl = rootEl.querySelector('.full-width-gallery__swiper');
  if (!swiperEl) {
    return;
  }

  const prevEl = rootEl.querySelector('.swiper-nav__button--prev');
  const nextEl = rootEl.querySelector('.swiper-nav__button--next');
  if (!prevEl || !nextEl) {
    return;
  }

  const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
  if (slideCount <= 1) {
    setNavDisabled(prevEl, true);
    setNavDisabled(nextEl, true);
    return;
  }

  if (swiperEl.swiper) {
    swiperEl.swiper.destroy(true, true);
  }

  const swiper = new Swiper(swiperEl, {
    modules: [Navigation, Keyboard, A11y],
    slidesPerView: 1,
    loop: false,
    allowTouchMove: true,
    observer: true,
    observeParents: true,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    a11y: {
      enabled: true,
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
    },
    navigation: {
      prevEl,
      nextEl,
    },
    on: {
      init(swiperInstance) {
        setNavDisabled(prevEl, swiperInstance.isBeginning);
        setNavDisabled(nextEl, swiperInstance.isEnd);
      },
      slideChange(swiperInstance) {
        setNavDisabled(prevEl, swiperInstance.isBeginning);
        setNavDisabled(nextEl, swiperInstance.isEnd);
      },
      fromEdge(swiperInstance) {
        setNavDisabled(prevEl, swiperInstance.isBeginning);
        setNavDisabled(nextEl, swiperInstance.isEnd);
      },
      reachBeginning() {
        setNavDisabled(prevEl, true);
      },
      reachEnd() {
        setNavDisabled(nextEl, true);
      },
    },
  });

  setNavDisabled(prevEl, swiper.isBeginning);
  setNavDisabled(nextEl, swiper.isEnd);

  const onContentClick = (e) => {
    const content = e.target.closest('.full-width-gallery__content');
    if (!content) {
      return;
    }

    if (!swiper.isEnd) {
      swiper.slideNext();
    }
  };

  fullWidthGalleryClickHandlers.set(rootEl, onContentClick);
  rootEl.addEventListener('click', onContentClick);
}

function initAllFullWidthGalleries() {
  document.querySelectorAll('.full-width-gallery').forEach((rootEl) => {
    initFullWidthGalleryRoot(rootEl);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initAllFullWidthGalleries();
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds-full-width-gallery', () => {
      initAllFullWidthGalleries();
    });
  }
});
